// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__31X7B","dragIcon":"Choice_dragIcon__g2ai6","left":"Choice_left__Ct0wh","input":"Choice_input__3P31V"};